import React from "react";

import Logo from "../../../../assets/images/micelu-acinco.png";
import VirginLogo from "../../../../assets/images/logo_virgin_acinco.png";
import UnluloLogo from "../../../../assets/images/unlulo_logo.png";
import CellsiteLogo from "../../../../assets/images/logo_cellsite.jpg";
import EnelLogo from "../../../../assets/images/enel_axa.png";
import CelufioLogo from "../../../../assets/images/logo_celufio.webp";
import CredicellLogo from "../../../../assets/images/credicell_logo.png";
import CeluplanetLogo from "../../../../assets/images/celuplanet_logo.jpg";
import CellZoneLogo from "../../../../assets/images/cellzone_logo.png";
import CredicelExpressLogo from "../../../../assets/images/credicelexpress_logo.png";
import IphonerosLogo from "../../../../assets/images/iphoneros_logo.png";
import PochocellLogo from "../../../../assets/images/pochocell_logo.png";
import OfertacelLogo from "../../../../assets/images/ofertacel_logo.jpg";
import MovilExpressLogo from "../../../../assets/images/logo_movilexpress.png";
import SmartketLogo from "../../../../assets/images/smarket_logo.jpg";
import AlocentralmovilLogo from "../../../../assets/images/alocentralmovil_logo.png";
import Thaniacellogo from "../../../../assets/images/logo_thaniacel.png";
import SmartGadgetsLogo from "../../../../assets/images/logo_smartgadgets.jpeg";
import EquismobileLogo from "../../../../assets/images/equis_logo.jpg";
import ToptradingLogo from "../../../../assets/images/logo_toptrading.png";
import GreenelectronicsLogo from "../../../../assets/images/logo_greenelectronics.jpeg";
import { Link } from "react-router-dom";
import { useAgentsAdminContext } from "../providers/agents-admin.provider";

const Navbar = () => {
  const { sponsor, config } = useAgentsAdminContext();
  const logo = () => {
    // Prioriza el logo del detalle (getDetails); si no viene, usa el hardcoded.
    if (config?.logoUrl) {
      return (
        <img
          alt={`${sponsor}_logo`}
          src={config.logoUrl}
          className="img-fluid w-full"
        />
      );
    }
    switch (sponsor) {
      case "virgin":
        return (
          <img
            alt="virgin_acinco_logo"
            src={VirginLogo}
            className="img-fluid w-full"
          />
        );
      case "micelu":
        return (
          <img
            alt="micelu_acinco_logo"
            src={Logo}
            className="img-fluid w-full"
          />
        );
      case "icali":
      case "icali2":
        return (
          <img
            alt="icali_acinco_logo"
            src={
              "https://files-statics-protegeme.s3.us-east-1.amazonaws.com/ICALI/logo_icali.jpg"
            }
            className="img-fluid w-full"
          />
        );
      case "unlulo":
        return (
          <img
            alt="unlulo_logo"
            src={UnluloLogo}
            className="img-fluid w-full"
          />
        );
      case "cellsite":
        return (
          <img
            alt="cellsite_logo"
            src={CellsiteLogo}
            className="img-fluid w-full"
          />
        );
      case "enel":
        return (
          <img
            alt="enel_axa_logo"
            src={EnelLogo}
            className="img-fluid w-full"
          />
        );
      case "celufio":
        return (
          <img
            alt="celufio_logo"
            src={CelufioLogo}
            className="img-fluid mb-8 w-full"
          />
        );
      case "credicell":
        return (
          <img
            alt="credicell_logo"
            src={CredicellLogo}
            className="img-fluid mb-8 w-full"
          />
        );
      case "celuplanet":
        return (
          <img
            alt="celuplanet_logo"
            src={CeluplanetLogo}
            className="img-fluid mb-8 w-full"
          />
        );
      case "cellzone":
        return (
          <img
            alt="cellzone_logo"
            src={CellZoneLogo}
            className="img-fluid mb-0 w-full"
          />
        );
      case "credicelexpress":
        return (
          <img
            alt="credicelexpress_logo"
            src={CredicelExpressLogo}
            className="img-fluid mb-0 w-20"
          />
        );
      case "iphoneros":
        return (
          <img
            alt="iphoneros_logo"
            src={IphonerosLogo}
            className="img-fluid mb-0 w-60"
          />
        );
      case "pochocell":
        return (
          <img
            alt="pochocell_logo"
            src={PochocellLogo}
            className="img-fluid mb-0 w-96"
          />
        );
      case "ofertacel":
        return (
          <img
            alt="ofertacel_logo"
            src={OfertacelLogo}
            className="img-fluid mb-0 w-32"
          />
        );
      case "movilexpress":
        return (
          <img
            alt="movilexpress_logo"
            src={MovilExpressLogo}
            className="img-fluid mb-0 w-60"
          />
        );
      case "smartket":
        return (
          <img
            alt="smartket_logo"
            src={SmartketLogo}
            className="img-fluid mb-0 w-60"
          />
        );
      case "alocentralmovil":
        return (
          <img
            alt="alocentralmovil_logo"
            src={AlocentralmovilLogo}
            className="img-fluid mb-0 w-60"
          />
        );
      case "thaniacel":
        return (
          <img
            alt="thaniacel_logo"
            src={Thaniacellogo}
            className="img-fluid mb-0 w-60"
          />
        );
      case "smartgadgets":
        return (
          <img
            alt="smartgadgets_logo"
            src={SmartGadgetsLogo}
            className="img-fluid mb-0 w-60"
          />
        );
      case "equismobile":
        return (
          <img
            alt="equismobile_logo"
            src={EquismobileLogo}
            className="img-fluid mb-0 w-60"
          />
        );
      case "toptrading":
        return (
          <img
            alt="toptrading_logo"
            src={ToptradingLogo}
            className="img-fluid mb-0 w-60"
          />
        );
      case "greenelectronics":
        return (
          <img
            alt="greenelectronics_logo"
            src={GreenelectronicsLogo}
            className="img-fluid mb-0 w-24"
          />
        );
      default:
        return (
          <img
            alt="micelu_acinco_logo"
            src={Logo}
            className="img-fluid w-full"
          />
        );
    }
  };
  return (
    <nav className={`fixed z-40 w-full bg-white`}>
      <div className="max-w-screen flex lg:justify-between">
        <div className="ml-10 flex w-full items-center justify-start px-5 lg:justify-center lg:px-0 xl:w-2/6 2xl:w-2/6">
          <Link to={`/${sponsor}/admin/home`}>
            <div className="my-5 -ml-7 w-20 pt-5 lg:pt-2">{logo()}</div>
          </Link>
        </div>
        <div className="flex w-full items-center justify-center px-5">
          <h3 className="text-center text-xl">Panel Administración Agentes</h3>
        </div>
      </div>
    </nav>
  );
};
export default Navbar;
